module.exports = __webpack_public_path__ + "img/cp-5.b7bf1b83.png";